export { InstagramPost } from './InstagramPost';
